export default __webpack_public_path__ + "static/media/j14.a83fefd4.jpg";